import { Trans } from "react-i18next";
import React from "react";
import { Button, Modal } from "react-bootstrap";

type CriticalNotification = {
  notification_id: string;
  title: string;
  message: string;
  action_url?: string | null;
};

type CriticalNotificationModalProps = {
  notification: CriticalNotification;
  onAcknowledge: (notificationId: string) => void;
  onOpen: (notification: CriticalNotification) => void;
};

/**
 * Isolated so UnifiedNotificationsProvider does not statically import
 * react-bootstrap (vendor-ui) onto the authenticated worklist boot graph.
 */
const CriticalNotificationModal: React.FC<CriticalNotificationModalProps> = ({
  notification,
  onAcknowledge,
  onOpen,
}) => {
  return (
    <Modal show backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>
          <Trans ns="features" i18nKey="ui.copy.00d3a0cf6b78" />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h5 className="mb-2">{notification.title}</h5>
        <p className="mb-0">{notification.message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-light"
          onClick={() => onAcknowledge(notification.notification_id)}
        >
          <Trans ns="features" i18nKey="ui.copy.9beb96dac88f" />
        </Button>
        <Button variant="primary" onClick={() => onOpen(notification)}>
          <Trans ns="features" i18nKey="ui.copy.b51dbd6a3021" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CriticalNotificationModal;
